<template>
  <div>
    <v-dialog v-model="dialog" width="75%">
      <v-card>
        <v-card-title class="mx-3">
          <span class="headline">{{
            $t("MovePositionOrder.StockBatchDialog.title")
          }}</span>
          <v-spacer></v-spacer>
          <v-tooltip left>
            <template v-slot:activator="{ on, attrs }">
              <v-icon v-bind="attrs" v-on="on" @click="dialog = false">
                fa-times
              </v-icon>
            </template>
            <span>
              {{ $t("$vuetify.close") }}
            </span>
          </v-tooltip>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row dense align="center">
              <v-col cols="12" sm="5" md="6">
                <SearcherKeyword
                  :label="
                    $t(
                      'MovePositionOrder.StockBatchDialog.stockBatchCodeSearch'
                    )
                  "
                  v-model="seacherStockBatchCodeKeyword"
                  @text="stockBatchCodeKeyword = $event"
                />
              </v-col>
              <v-col cols="12" sm="5" md="4">
                <!-- 状态 -->
                <SearcherStatus
                  v-model="stockBatchStatus"
                  :items="$consts.expiredFlgs"
                  :label="
                    $t(
                      'MovePositionOrder.StockBatchDialog.stockBatchStatusSearch'
                    )
                  "
                />
              </v-col>
            </v-row>
            <v-data-table
              :headers="stockBatchHeaders"
              :items="stockPositionBatchItems"
              :loading="loading"
              multi-sort
              disable-pagination
              hide-default-footer
              class="elevation-0 px-6"
              fixed-header
              height="360px"
              v-model="showSelected"
              show-select
            >
              <template v-slot:item.stock_detail.stock_batch_code="{ item }">
                {{ item.stock_detail.stock_batch_code }}
                <v-chip
                  v-if="item.stock_detail.expired_flg"
                  x-small
                  label
                  :color="item.stock_detail.expired_flg | expiredFlgsColor"
                  :text-color="
                    item.stock_detail.expired_flg | expiredFlgsTextColor
                  "
                >
                  {{ item.stock_detail.expired_flg | expiredFlgsText }}
                </v-chip>

                <v-chip
                  v-if="item.stock_detail.prohibit_flg"
                  small
                  label
                  :color="item.stock_detail.prohibit_flg | prohibitFlgsColor"
                  :text-color="
                    item.stock_detail.prohibit_flg | prohibitFlgsTextColor
                  "
                >
                  {{ item.stock_detail.prohibit_flg | prohibitFlgsText }}
                </v-chip>
              </template>
              <template v-slot:item.production_date="{ item }">
                {{ item.production_date | formatDate }}
              </template>
              <template v-slot:item.expired_date="{ item }">
                {{ item.expired_date | formatDate }}
              </template>
            </v-data-table>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" outlined @click="dialog = false">{{
            $t("$vuetify.close")
          }}</v-btn>
          <v-btn color="accent" @click="submit()">
            {{ $t("StockContainers.selectContainer.confirm") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import i18n from "@/i18n";
import { mapState } from "vuex";
import SearcherKeyword from "@/components/plugins/SearcherKeyword";
import SearcherStatus from "@/components/plugins/SearcherStatus";
import StockDetails from "@/api/stock_details";

export default {
  name: "SelectStockBatchDialog",

  props: {
    value: Boolean,
    label: String,
    stockBatch: Array,
    stockPositionId: Number,
    materialId: Number,
    selectedData: Array,
    mode: String,
    stockId: Number,
    stock: Object,
    deleteStockCount: Boolean,
  },

  components: {
    SearcherKeyword,
    SearcherStatus,
  },

  computed: {
    stockPositionBatchItems() {
      return this.stockPositionBatchs.filter(
        (batch) =>
          ((this.stockBatchCodeKeyword &&
            batch.stock_batch_code.indexOf(this.stockBatchCodeKeyword) != -1) ||
            !this.stockBatchCodeKeyword) &&
          ((this.stockBatchStatus.length &&
            this.stockBatchStatus.find((s) => s == batch.expired_flg) !=
              undefined) ||
            !this.stockBatchStatus.length)
      );
    },
    stockBatchHeaders() {
      var headers = [
        {
          text: i18n.t(
            "MovePositionOrder.StockBatchDialog.DetailFieds.material"
          ),
          align: "center",
          sortable: false,
          value: "MaterialDescription",
        },
      ];
      if (this.mode == "new") {
        headers.push({
          text: i18n.t(
            "MovePositionOrder.StockBatchDialog.DetailFieds.position"
          ),
          align: "center",
          sortable: false,
          value: "PositionDescription",
        });
      }
      headers.push(
        {
          text: i18n.t(
            "MovePositionOrder.StockBatchDialog.DetailFieds.stock_batch_code"
          ),
          align: "center",
          sortable: false,
          value: "stock_batch_code",
        },
        {
          text: i18n.t(
            "MovePositionOrder.StockBatchDialog.DetailFieds.production_date"
          ),
          align: "center",
          sortable: false,
          value: "production_date",
        },
        {
          text: i18n.t(
            "MovePositionOrder.StockBatchDialog.DetailFieds.expired_date"
          ),
          align: "center",
          sortable: false,
          value: "expired_date",
        }
      );
      return headers;
    },

    // 使用对象展开运算符将此对象混入到外部对象中
    ...mapState(["loading", "settings", "accountUser"]),
  },

  data: () => ({
    dialog: false,
    stockPositionBatchs: [],
    seacherStockBatchCodeKeyword: "",
    stockBatchCodeKeyword: "",
    stockBatchStatus: [0, 1],
    showSelected: [],
    searchStockBatchs: [],
  }),

  methods: {
    submit() {
      var showSelectedId = [];
      this.showSelected.map((selected) => {
        showSelectedId.push(selected.id);
      });

      this.$emit("stockBatchSeleted", this.showSelected);
      this.dialog = false;
    },
  },

  watch: {
    value: {
      immediate: true, //初始赋值也调用
      handler() {
        if (this.value) {
          this.dialog = true;
        }
      },
    },
    dialog: {
      handler() {
        this.$emit("input", this.dialog);
        if (!this.dialog) {
          this.showSelected = [];
        }
      },
    },
    materialId: {
      handler() {
        if (this.materialId) {
          if (this.mode == "new" && this.stockPositionId) {
            var data = {
              stock_position_id: this.stockPositionId,
              material_id: this.materialId,
            };
            if (this.deleteStockCount) {
              data = Object.assign({}, data, {
                delete_stock_count: 1,
              });
            }
            StockDetails.fetchByPositionMaterial(data).then(
              function (response) {
                if (response.data.status.isOK()) {
                  this.stockPositionBatchs = response.data.stock_details.map(
                    (batch) => {
                      var PositionDescription = i18n.t(
                        "MovePositionOrder.DetailFields.position",
                        [
                          batch.stock_material_position.stock_position
                            .position_code,
                          batch.stock_material_position.stock_position
                            .position_name,
                        ]
                      );
                      if (this.stock && this.stock.position_name_display) {
                        if (this.stock.position_name_display.indexOf(2) > -1) {
                          PositionDescription =
                            batch.stock_material_position.stock_position
                              .position_name;
                        }
                        if (
                          this.stock.position_name_display.indexOf(4) > -1 &&
                          batch.stock_material_position.stock_position
                            .stock_roadway
                        ) {
                          PositionDescription =
                            batch.stock_material_position.stock_position
                              .stock_roadway.code +
                            " - " +
                            PositionDescription;
                        }
                        if (
                          this.stock.position_name_display.indexOf(3) > -1 &&
                          batch.stock_material_position.stock_position
                            .stock_area
                        ) {
                          PositionDescription =
                            batch.stock_material_position.stock_position
                              .stock_area.area_name +
                            " - " +
                            PositionDescription;
                        }
                      }

                      const MaterialDescription = i18n.t(
                        this.settings
                          ? this.settings.material_name_display_type == 4
                            ? "Material.nameWithCodeAndStandard"
                            : this.settings.material_name_display_type == 3
                            ? "Material.materialNameWithCodeAndStandard"
                            : this.settings.material_name_display_type == 2
                            ? "Material.materialNameWithCode"
                            : "Material.materialName"
                          : "Material.materialName",
                        [
                          batch.material.material_code,
                          batch.material.material_name,
                          batch.material.standard ? ( batch.material.standard.name ? ( batch.material.standard.name.length > 12 ? batch.material.standard.name.slice(0, 12) + "......" :  batch.material.standard.name) : "") : '',
                        ]
                      );

                      return Object.assign({}, batch, {
                        PositionDescription,
                        MaterialDescription,
                      });
                    }
                  );
                }
              }.bind(this)
            );
          } else if (this.mode == "batchNew" && this.stockId) {
            StockDetails.fetch({
              stock_ids: this.stockId,
              material_ids: this.materialId,
              status: [0, 2],
            }).then(
              function (response) {
                if (response.data.status.isOK()) {
                  this.stockPositionBatchs = response.data.stock_details.map(
                    (batch) => {
                      const MaterialDescription = i18n.t(
                        this.settings
                          ? this.settings.material_name_display_type == 4
                            ? "Material.nameWithCodeAndStandard"
                            : this.settings.material_name_display_type == 3
                            ? "Material.materialNameWithCodeAndStandard"
                            : this.settings.material_name_display_type == 2
                            ? "Material.materialNameWithCode"
                            : "Material.materialName"
                          : "Material.materialName",
                        [
                          batch.material.material_code,
                          batch.material.material_name,
                          batch.material.standard_name,
                        ]
                      );

                      return Object.assign({}, batch, {
                        MaterialDescription,
                      });
                    }
                  );
                }
              }.bind(this)
            );
          }
        }
      },
    },
    seacherStockBatchCodeKeyword: {
      handler() {
        this.stockBatchCodeKeyword = this.seacherStockBatchCodeKeyword;
      },
    },
    stockPositionBatchs: {
      handler() {
        this.stockPositionBatchs.forEach((batch) => {
          if (new Date(batch.expired_date).getTime() < new Date().getTime()) {
            batch.expired_flg = 1;
          } else {
            batch.expired_flg = 0;
          }
        });
      },
    },
    selectedData: {
      handler() {
        if (this.selectedData.length) {
          this.showSelected = this.selectedData;
        }
      },
    },
  },
};
</script>